//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import { useNavigate } from 'react-router-dom'
//import LeagueDatabaseTable from '../LeagueDatabaseTable'

const SearchByLeagueForStandings = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeagues, setLoadedLeagues] = useState()
	const [loadedDivisions, setLoadedDivisions] = useState()
	const [error, setError] = useState()

	let selectedLeague, selectedTeam, selectedVenue, selectedDivision
	//******************************************************* */
	//
	//Call backend to get all the current leagues for our dropdown
	//
	//    admin-controller   getCurrentLeagues
	//
	//******************************************************** */
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current'
				)

				const responseData = await response.json()

				//console.log('responseData: ' + JSON.stringify(responseData))

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedLeagues(responseData.currentLeagues)
				setLoadedDivisions(responseData.divisions)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedLeagues])

	let leagueArray, divisionArray

	if (loadedLeagues && !isLoading) {
		leagueArray = []
		loadedLeagues.forEach((league) => {
			const leagueDisplay = league.leagueName + ' - ' + league.year
			leagueArray.push(leagueDisplay)
		})
	}
	//
	if (loadedDivisions && !isLoading) {
		divisionArray = []
		loadedDivisions.forEach((div) => {
			divisionArray.push(div)
		})
	}
	//

	//console.log('loadedTeams: ' + JSON.stringify(loadedTeams))

	let navigate = useNavigate()

	//For handling a search by league request:
	const handleChange = (e) => {
		e.preventDefault()
		if (e.target.value === '*Previous Tournaments*') {
			navigate('/league/previousLeagues')
		} else if (e.target.value !== 'Search for Tournament Schedule....') {
			const selectedValue = e.target.value
			selectedLeague = loadedLeagues[selectedValue]
			const leagueId = selectedLeague._id
			navigate(`/league/${leagueId}`)
		}
	}

	return (
		<React.Fragment>
			<div className='searchbyleagueorvenue' style={{ marginTop: '0rem' }}>
				<div className='row'>
					<div className='LTVinstructions'>Find a Tournament: </div>
				</div>
				{!isLoading && loadedLeagues && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								<select
									className='scheduleselectornonadmin'
									onChange={handleChange}
								>
									<option defaultValue>
										Search for Tournament Standings...
									</option>
									{leagueArray.map((league, i) => (
										<option value={i} key={i}>
											{league}
										</option>
									))}
									<option style={{ background: '#dff3fb' }}>
										*Previous Tournaments*
									</option>
								</select>
							</form>
						</div>
						<div className='col'></div>
					</div>
				)}
			</div>
		</React.Fragment>
	)
}

export default SearchByLeagueForStandings
